module.exports = __webpack_public_path__ + "static/media/avatar.98e2d8f7.png";